import classNames from 'classnames';
import dayjs from 'dayjs';
import { useIssuerGetCertificatesQuery } from '@/modules/issuer-dashboard/queries/certificates.ts';
import { Badge, ChartEmptyState, InfoCard } from 'ui';
import { DownloadGreyIcon } from 'ui/icons';
import { ShareCertificateResponse, ShareCertificateStatus } from 'api';

export const LastCertificate = () => {
  const { data, isError, isFetching } = useIssuerGetCertificatesQuery({
    page: 1,
    page_size: 6,
  });

  const certificates = (data?.pages || []).flatMap(({ data }) => data);

  return (
    <InfoCard title="Last certificates" classes={{ content: 'w-full' }}>
      <div className="flex flex-col gap-4 w-full">
        {(!certificates?.length || isFetching) && (
          <div className="py-4 flex justify-center items-center font-medium text-lg">
            <ChartEmptyState isError={isError} isLoading={isFetching} />
          </div>
        )}
        {!isFetching && certificates?.map(item => <CertificateItem key={item.id} item={item} />)}
      </div>
    </InfoCard>
  );
};

interface CertificateItemProps {
  item: ShareCertificateResponse;
}

const CertificateItem = ({ item }: CertificateItemProps) => {
  const { status, file_storage_item_url, entity, register_class, created_at } = item;
  return (
    <div className="flex items-start justify-between w-full gap-4">
      <div className="flex flex-col max-w-[180px] sm:max-w-full">
        <div className="text-sm leading-[22px] font-[Inter] flex items-center gap-2">
          <div className="text-gray-900 whitespace-nowrap 2xl:max-w-[350px] sm:max-w-[200px] max-w-[130px] overflow-hidden text-ellipsis">
            {entity?.entity_name ?? ''}
          </div>{' '}
          <div className="text-[#E5E5E5]">|</div>
          <div className="text-gray-900 whitespace-nowrap 2xl:max-w-[200px] sm:max-w-[150px] max-w-[50px] overflow-hidden text-ellipsis">
            {register_class?.class_name ?? ''}
          </div>
        </div>
        <div className="text-xs leading-5 text-[#737373]">
          {dayjs(created_at).format('DD-MM-YYYY')}
        </div>
      </div>
      <div className="flex sm:gap-6 gap-3 items-center">
        <Badge
          containerClass={classNames('text-white capitalize w-fit text-xs leading-5 font-[Inter]', {
            'bg-green-600': status === ShareCertificateStatus.Current,
            'bg-gray-400': status === ShareCertificateStatus.Outdated,
          })}
        >
          {status}
        </Badge>
        {file_storage_item_url ? (
          <span className="cursor-pointer hover:opacity-80" onClick={e => e.stopPropagation()}>
            <a href={file_storage_item_url} target="_blank" rel="noopener noreferrer">
              <img
                alt="cerificate"
                src={DownloadGreyIcon}
                className="w-6 h-6 min-w-[24px] min-h-[24px]"
              />
            </a>
          </span>
        ) : (
          <></>
        )}
      </div>
    </div>
  );
};
